import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';
import {
  createIngredient,
  getIngredientsByPage,
} from '../../ApiServices/IngredientServices';
import { handleResponse } from '../../ApiServices/ApiHandler';
import { t } from 'i18next';

export const initialState = {
  value: { totalCount: -1, data: [] },
  loading: false,
  error: null,
  rowsPerPage: 10,
  pageNo: 0,
  selectedValue: null,
  message: null,
};

const ingredientsSlice = createSlice({
  name: 'ingredient',
  initialState: initialState,
  reducers: {
    clearIngredientsState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchIngredients.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.rowsPerPage = action?.meta?.arg?.limit;
    });
    builder.addCase(fetchIngredients.rejected, (state: any, action: any) => {
      state.loading = initialState.loading;
      state.error = action?.payload?.data;
    });
  },
});

export const ingredientsState = (state: RootState) => state?.ingredients;
export const { clearIngredientsState } = ingredientsSlice.actions;
export default ingredientsSlice.reducer;

export const fetchIngredients = createAsyncThunk(
  'ingredient/fetchIngredients',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_INGREDIENTS') }));
      return fulfillWithValue(await getIngredientsByPage(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const addIngredient = createAsyncThunk(
  'ingredient/addIngredient',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('ADDING_NEW_INGREDIENT_DETAILS') }));
      let response: any = await createIngredient(payload);
      if (response?.status === 200 || response === 200) {
        dispatch(
          showSuccessSnackbar({ message: t('INGREDIENT_CREATED_SUCCESS') })
        );
      } else {
        dispatch(
          showErrorSnackbar({ message: t('INGREDIENT_CREATION_FAILED') })
        );
      }
      return fulfillWithValue(response);
      // return await handleResponse(
      //   response,
      //   fulfillWithValue,
      //   rejectWithValue,
      //   dispatch
      // );
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
